export const HebrewNumbering = [
  "א",
  "ב",
  "ג",
  "ד",
  "ה",
  "ו",
  "ז",
  "ח",
  "ט",
  "י",
  "יא",
  "יב",
  "יג",
  "יד",
  "טו",
  "טז",
  "יז",
  "יח",
  "יט",
  "כ",
  "כא",
  "כב",
  "כג",
  "כד",
  "כה",
  "כו",
  "כז",
  "כח",
  "כט",
  "לא",
  "לב",
  "לג",
  "לד",
  "לה",
  "לו",
  "לז",
  "לח",
  "לט",
  "מא",
  "מב",
  "מג",
  "מד",
  "מה",
  "מו",
  "מז",
  "מח",
  "מט",
  "נ",
];



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/utils/hebrewNumbering.ts